import React from 'react';
import { ArrowIcon, ArrowIconButton } from './styles';

const ArrowRightButton = ({ onClickArrowRight }) => (
  <ArrowIconButton
    variant="contained"
    color="secondary"
    startIcon={<ArrowIcon />}
    onClick={onClickArrowRight}
  />
);

export default ArrowRightButton;
